import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuthContext } from "../../../utils/authProvider";
import {
  Container,
  Row,
  Col,
  Spinner,
  Button,
  Modal,
  Table,
  ButtonGroup,
  Form,
  InputGroup,
  ListGroup,
  Card,
  Alert,
} from "react-bootstrap";
import StaticSiteSearchTool from "../../../utils/StaticSiteSearch";
import { fieldOptions } from "../../../utils/initDynamicOptions";
import DynamicApiCalls from "./dynamicApiCalls";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import CloseIcon from "@mui/icons-material/Close";
import "./SevenDayStyle.css";

const GasCardToday = (props) => {
  const navigate = useNavigate();
  const { getAuth, refreshCheck } = useAuthContext();

  const [todaysDate, setTodaysDate] = useState("");
  const [yesterdaysDate, setYesterdaysDate] = useState("");
  const [dayBeforeYesterdaysDate, setDayBeforeYesterdaysDate] = useState("");
  const [userCardOptions, setUserCardOptions] = useState([]);
  const [userCardOptionsUpdate, setUserCardOptionsUpdate] = useState([]);
  const [userDynamicOptions, setUserDynamicOptions] = useState([]);
  const [instance, setInstance] = useState([]);
  const [xref, setXref] = useState([]);
  const [cardNameForm, setCardNameForm] = useState({});
  const [cardName, setCardName] = useState("");

  const [filteredDynamicOptions, setFilteredDynamicOptions] = useState([]);
  const comparisonOptions = ["=", "<>"];
  const [valueOptions, setValueOptions] = useState({});
  const [fieldCombiOptions, setFieldCombiOptions] = useState([
    { value: "Loading", key: "Loading" },
  ]);
  const [statOpts, setStatOpts] = useState([]);

  const [dynViewSiteList, setDynViewSiteList] = useState(false);
  const [dynSites, setDynSites] = useState([]);
  const [dynSiteCount, setDynSiteCount] = useState(0);
  const [dynSiteIds, setDynSiteIds] = useState([]);
  const [urOrSn, setUrOrSn] = useState("userRef");

  const [siteIds, setSiteIds] = useState([]);
  const [treeSave, setTreeSave] = useState(false);
  const [dataToday, setDataToday] = useState([]);
  const [dataYesterday, setDataYesterday] = useState([]);
  const [loading, setLoading] = useState(false);
  const [yestPercent, setYestPercent] = useState(0);
  const [yestPercentStyle, setYestPercentStyle] = useState("");
  const [todayGas, setTodayGas] = useState("");
  const [yesterdayGas, setYesterdayGas] = useState("");

  const [showRemoveCardAlert, setShowRemoveCardAlert] = useState(false);
  const handleShowRemoveCardAlert = () => setShowRemoveCardAlert(true);
  const handleCloseRemoveCardAlert = () => setShowRemoveCardAlert(false);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    if (siteIds.length > 0) {
      setShowStaticOrDynamic("static");
      setShow(true);
    } else if (siteIds.length <= 0 && filteredDynamicOptions.length > 0) {
      setShowStaticOrDynamic("dynamic");
      setShow(true);
    } else {
      setShowStaticOrDynamic("dynamic");
      setShow(true);
    }
  };
  const [showStaticOrDynamic, setShowStaticOrDynamic] = useState("static");
  const [rows, setRows] = useState([
    {
      fieldText: "",
      fieldValue: "",
      comparison: "",
      optionValue: "",
      optionText: "",
    },
  ]);
  const [sendRows, setSendRows] = useState([
    {
      fieldValue: "",
      comparison: "",
      optionValue: "",
    },
  ]);
  const [usePrevDaySwitch, setUsePrevDaySwitch] = useState(false);
  useEffect(() => {
    console.log(" usePrevDaySwitch", usePrevDaySwitch);
  }, [usePrevDaySwitch]);
  const [switchChanged, setSwitchChanged] = useState(false);

  useEffect(() => {
    setInstance(props.instance);
    getDates();
    getXref();
  }, []);
  useEffect(() => {
    initStaticOrDynamic();
    setUserCardOptions(props.userCardOptions);
    setUserDynamicOptions(props.userDynamicOptions);
  }, [instance]);
  useEffect(() => {
    const instanceOptions = userCardOptions.filter(
      (option) => option.instance_id === instance
    );
    const cardName = instanceOptions.find(
      (option) => option.option_id === "userDefName"
    )?.value;
    if (cardName === undefined) {
      setCardName("No name set");
    } else {
      setCardName(cardName);
    }
    const usePrevSwitch = instanceOptions.find(
      (option) => option.option_id === "usePrevDaySwitch"
    )?.value;
    if (usePrevSwitch === undefined) {
      setUsePrevDaySwitch(false);
    } else if (usePrevSwitch === "false") {
      setUsePrevDaySwitch(false);
    } else if (usePrevSwitch === "true") {
      setUsePrevDaySwitch(true);
    }
  }, [userCardOptions]);
  useEffect(() => {
    const filteredDynamicOptionsSet = userDynamicOptions.filter(
      (option) => option.instance_id === instance
    );
    setFilteredDynamicOptions(filteredDynamicOptionsSet);
    handleViewInitDynSites();
  }, [userDynamicOptions]);
  useEffect(() => {
    if (siteIds.length > 0) {
      getGasDataToday();
      getGasDataYesterday();
    }
    return;
  }, [siteIds]);
  useEffect(() => {
    if (dynSiteIds.length > 0) {
      getGasDataToday();
      getGasDataYesterday();
    }
    return;
  }, [dynSiteIds]);
  useEffect(() => {
    if (dataToday.length > 0) {
      setTodayGas(dataAdder(dataToday));
    }
    return;
  }, [dataToday]);
  useEffect(() => {
    if (dataYesterday.length > 0) {
      setYesterdayGas(dataAdder(dataYesterday));
    }
    return;
  }, [dataYesterday]);
  useEffect(() => {
    console.log("todayGas", todayGas);
    console.log("yesterdayGas", yesterdayGas);
    if (todayGas && yesterdayGas) {
      setYestPercent(todayVsYesterdayPercentage(yesterdayGas, todayGas));
    }
  }, [todayGas, yesterdayGas]);
  useEffect(() => {
    console.log("fieldCombiOptions", filteredDynamicOptions);
    const xrefUpdated = filteredDynamicOptions.map((option) => {
      const xrefItem = fieldCombiOptions.find(
        (item) => item.key === option.fieldId
      );
      if (xrefItem) {
        return {
          ...option,
          fieldText: xrefItem.value,
          fieldId: xrefItem.key,
        };
      }
      return option;
    });
    const userDynamicOptionsSet = xrefUpdated.map((option) => {
      return {
        fieldId: option.fieldId,
        fieldText: option.fieldText,
        comparison: option.operator,
        optionValue: option.value,
        optionText: option.text,
      };
    });
    setRows(userDynamicOptionsSet);
  }, [fieldCombiOptions]);
  useEffect(() => {
    const rowsToSend = rows.map((row) => {
      return {
        field: row.fieldId,
        operator: row.comparison,
        optionValue: row.optionValue,
      };
    });
    setSendRows(rowsToSend);
  }, [rows]);
  useEffect(() => {
    if (
      sendRows.some(
        (row) =>
          row.fieldValue === "" ||
          row.comparison === "" ||
          row.optionValue === ""
      )
    ) {
      return;
    } else {
      handleViewSites("init");
    }
  }, [sendRows]);
  useEffect(() => {
    if (treeSave === false) {
      return;
    } else if (treeSave === true) {
      cleanUpOptsToSend();
    }
  }, [treeSave]);
  useEffect(() => {
    if (statOpts.length === 0) {
      return;
    } else {
      updateStaticOptions();
    }
  }, [statOpts]);
  useEffect(() => {
    console.log("object userCardOptionsUpdate", userCardOptionsUpdate);
  }, [userCardOptionsUpdate]);
  const getDates = () => {
    const currentDateTest = new Date().toLocaleDateString("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    setTodaysDate(currentDateTest);
    const yesterdayDateTest = new Date(
      new Date().setDate(new Date().getDate() - 1)
    ).toLocaleDateString("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    setYesterdaysDate(yesterdayDateTest);
    const dayBeforeYesterdayDateTest = new Date(
      new Date().setDate(new Date().getDate() - 2)
    ).toLocaleDateString("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    setDayBeforeYesterdaysDate(dayBeforeYesterdayDateTest);
  };
  const getXref = async () => {
    const initFieldOptions = fieldOptions;
    const auth = await getAuth();
    const options = {
      method: "GET",
      url: "https://api.pramsplus.com/xref-labels",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${auth}`,
      },
    };
    try {
      const response = await axios.request(options);
      setXref(response.data);
      setFieldCombiOptions([...response.data, ...initFieldOptions]);
    } catch (err) {
      console.log(err.response.status);
      if (err.response.status === 401) {
        const valid = await refreshCheck("getXref");
        if (valid === true) {
          console.log("Retrying groups api call");
          getXref();
        } else if (valid === false) {
          console.log("all retries failed getXref");
          navigate("/login");
        }
      } else {
        console.log(
          "Redirecting to login something went wrong in call getXref"
        );
        navigate("/login");
      }
      return;
    }
  };
  const getGasDataToday = async () => {
    setLoading(true);
    setDataToday([]);
    const authT = await getAuth();
    let siteIdsPrep = [];
    if (siteIds.length > 0) {
      siteIdsPrep = siteIds;
    } else {
      siteIdsPrep = dynSiteIds;
    }
    console.log("todaysDate", todaysDate);
    console.log("yesterdaysDate", yesterdaysDate);
    console.log("usePrevDaySwitch", usePrevDaySwitch);
    const siteArrayData = {
      siteIds: siteIdsPrep,
      from: usePrevDaySwitch ? yesterdaysDate : todaysDate,
      to: usePrevDaySwitch ? yesterdaysDate : todaysDate,
    };
    const options = {
      method: "POST",
      url: "https://api.pramsplus.com/daily_site",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authT}`,
      },
      data: siteArrayData,
    };
    if (options && siteArrayData) {
      await axios
        .request(options)
        .then(function (response) {
          console.log("today's gas data done", response.data.items);
          setDataToday(response.data.items);
          setLoading(false);
          siteIdsPrep = [];
        })
        .catch(function (error) {
          console.error(error);
          refreshCheck();
        });
    } else {
      // console.log("no options");
    }
  };
  const getGasDataYesterday = async () => {
    setLoading(true);
    setDataYesterday([]);
    const authT = await getAuth();
    let siteIdsPrep = [];
    if (siteIds.length > 0) {
      siteIdsPrep = siteIds;
    } else {
      siteIdsPrep = dynSiteIds;
    }
    const siteArrayData = {
      siteIds: siteIdsPrep,
      from: usePrevDaySwitch ? dayBeforeYesterdaysDate : yesterdaysDate,
      to: usePrevDaySwitch ? dayBeforeYesterdaysDate : yesterdaysDate,
    };
    const options = {
      method: "POST",
      url: "https://api.pramsplus.com/daily_site",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authT}`,
      },
      data: siteArrayData,
    };
    if (options && siteArrayData) {
      axios
        .request(options)
        .then(function (response) {
          setDataYesterday(response.data.items);
          setLoading(false);
          siteIdsPrep = [];
        })
        .catch(function (error) {
          console.error(error);
          refreshCheck();
        });
    } else {
      console.log("no options");
    }
  };
  const dataAdder = (data) => {
    const sum = data.reduce((total, item) => {
      return total + item.grossGas;
    }, 0);
    return sum.toFixed(2);
  };
  const todayVsYesterdayPercentage = (yesterday, today) => {
    const yesterdayNum = parseFloat(yesterday);
    const todayNum = parseFloat(today);
    const percentage = ((todayNum - yesterdayNum) / yesterdayNum) * 100;
    if (percentage > 0) {
      setYestPercentStyle(" text-success");
      return `+${percentage.toFixed(2)}%`;
    } else if (percentage < 0) {
      setYestPercentStyle("text-danger");
      return `${percentage.toFixed(2)}%`;
    } else {
      return "0%";
    }
  };
  const toggleStaticDynamic = (type) => {
    if (type === "static") {
      setShowStaticOrDynamic("static");
    }
    if (type === "dynamic") {
      setShowStaticOrDynamic("dynamic");
    }
  };
  const initStaticOrDynamic = () => {
    const dynamicOptions = userDynamicOptions.filter(
      (option) => option.instance_id === instance
    );
    if (dynamicOptions.length > 0) {
      setShowStaticOrDynamic("dynamic");
    } else {
      const pullInstanceOptions = props.userCardOptions.filter(
        (option) => option.instance_id === instance
      );
      const pullStat = pullInstanceOptions.find(
        (option) => option.option_id === "staticSiteList"
      )?.value;
      if (pullStat === undefined) {
        setShowStaticOrDynamic("dynamic");
        return;
      } else {
        const staticSiteList = pullStat.split(",");
        if (staticSiteList.length > 0) {
          setShowStaticOrDynamic("static");
          setSiteIds(staticSiteList);
        }
      }
    }
  };
  const handleFieldChange = (index, value, label) => {
    setRows((current) => {
      const newRows = current.map((row, i) => {
        if (i === index) {
          return { ...row, fieldId: value, fieldText: label };
        }
        return row;
      });
      return newRows;
    });
    callDynamicApi(value);
  };
  const handleComparisonChange = (index, value) => {
    setRows((current) => {
      const newRows = current.map((row, i) => {
        if (i === index) {
          return { ...row, comparison: value };
        }
        return row;
      });
      return newRows;
    });
  };
  const handleValueChange = (index, value, label) => {
    setRows((current) => {
      const newRows = current.map((row, i) => {
        if (i === index) {
          return { ...row, optionText: label, optionValue: value };
        }
        return row;
      });
      return newRows;
    });
  };
  const addDynamicRow = () => {
    setRows((current) => [
      ...current,
      {
        fieldId: "",
        fieldText: "",
        comparison: "",
        optionValue: "",
        optionText: "",
      },
    ]);
  };
  const callDynamicApi = async (field) => {
    const auth = await getAuth();
    const res = await DynamicApiCalls(field, auth);
    setValueOptions((prevState) => ({
      ...prevState,
      [field]: res,
    }));
  };
  const handleDeleteRow = (event, index) => {
    event.preventDefault();
    const newRows = [...rows];
    newRows.splice(index, 1);
    setRows(newRows);
  };
  const handleViewSites = async (props) => {
    if (props === "init") {
      return;
    } else {
      if (showStaticOrDynamic === "static") {
        return;
      } else {
        if (props === "button") {
          setDynViewSiteList(true);
        } else {
          setDynViewSiteList(false);
        }
        const dynList = sendRows;
        const auth = await getAuth();
        const options = {
          method: "POST",
          url: "https://api.pramsplus.com/site-dynamic",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${auth}`,
          },
          data: dynList,
        };
        try {
          const response = await axios.request(options);
          setDynSites(response.data);
          setDynSiteCount(response.data.length);
          setDynSiteIds(response.data.map((site) => site.siteId));
          setSiteIds([]);
        } catch (err) {
          console.log(err.response.status);
          if (err.response.status === 401) {
            const valid = await refreshCheck("handleViewSites");
            if (valid === true) {
              console.log("Retrying handleViewSites api call");
              handleViewSites();
            } else if (valid === false) {
              console.log("all retries failed handleViewSites");
              navigate("/login");
            }
          } else {
            console.log(
              "Redirecting to login something went wrong in handleViewSites"
            );
            navigate("/login");
          }
          return;
        }
      }
    }
  };
  const handleViewInitDynSites = async () => {
    if (userDynamicOptions.length === 0) {
      return;
    } else {
      const auth = await getAuth();
      const initOptions = userDynamicOptions.filter(
        (option) => option.instance_id === instance
      );
      const dynList = initOptions.map((option) => {
        return {
          field: option.fieldId,
          operator: option.operator,
          optionValue: option.value,
        };
      });
      if (dynList.length === 0) {
        return;
      }
      const options = {
        method: "POST",
        url: "https://api.pramsplus.com/site-dynamic",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${auth}`,
        },
        data: dynList,
      };
      try {
        const response = await axios.request(options);
        setDynSites(response.data);
        setDynSiteCount(response.data.length);
        setDynSiteIds(response.data.map((site) => site.siteId));
        setSiteIds([]);
      } catch (err) {
        console.log(err.response.status);
        if (err.response.status === 401) {
          const valid = await refreshCheck("handleViewInitDynSites");
          if (valid === true) {
            console.log("Retrying handleViewInitDynSites api call");
            handleViewInitDynSites();
          } else if (valid === false) {
            console.log("all retries failed handleViewInitDynSites");
            navigate("/login");
          }
        } else {
          console.log(
            "Redirecting to login something went wrong in handleViewInitDynSites"
          );
          navigate("/login");
        }
        return;
      }
    }
  };
  const saveOptionsStatic = async () => {
    if (cardNameForm.Card_Name === undefined && switchChanged === false) {
      return;
    } else if (cardNameForm.Card_Name === undefined && switchChanged === true) {
      await saveUsePreviousDaySwitch();
    } else if (
      cardNameForm.Card_Name !== undefined &&
      switchChanged === false
    ) {
      await saveCardName(1);
    } else if (cardNameForm.Card_Name !== undefined && switchChanged === true) {
      await saveCardName(2);
    }
  };
  const nextSetOfOptions = async (sites) => {
    setSiteIds(sites);
    setShow(false);
    setTreeSave(true);
  };
  const saveSitesTreeForStatic = async (sites) => {
    console.log("going to save static Card Name");
    await saveOptionsStatic();
    console.log("Clearing Dyn Options");
    await clearDynOptions();
    console.log("Running next options");
    await nextSetOfOptions(sites);
  };
  const saveOptionsDynamic = async () => {
    console.log("cardNameForm", cardNameForm.Card_Name);
    if (cardNameForm.Card_Name === undefined && switchChanged === false) {
      return;
    } else if (cardNameForm.Card_Name === undefined && switchChanged === true) {
      await saveUsePreviousDaySwitch();
    } else if (
      cardNameForm.Card_Name !== undefined &&
      switchChanged === false
    ) {
      await saveCardName(1);
    } else if (cardNameForm.Card_Name !== undefined && switchChanged === true) {
      await saveCardName(2);
    }
  };
  const saveSitesButtonForDynamic = async () => {
    if (showStaticOrDynamic === "static") {
      throw new Error("You shouldn't be able to do this!");
    } else {
      await saveOptionsDynamic();
      await updateDynamicOptions();
      await updateStaticOptionsViaDyn();
    }
  };
  const updateDynamicOptions = async () => {
    const dynList = rows;
    const optsToSend = dynList.map((option, index) => {
      return {
        optionId: index,
        field: option.fieldId,
        operator: option.comparison,
        optionValue: option.optionValue,
        optionText: option.optionText,
      };
    });
    const opts = {
      dynamicOptions: optsToSend,
    };
    const auth = await getAuth();
    const options = {
      method: "PATCH",
      url: `https://api.pramsplus.com/web-cards/${instance}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${auth}`,
      },
      data: opts,
    };
    console.log(" updateDynamicOptions ", options);
    try {
      const response = await axios.request(options);
      console.log("web card patch", response);
      props.reload();
    } catch (err) {
      console.log(err.response.status);
      if (err.response.status === 401) {
        const valid = await refreshCheck("updateDynamicOptions");
        if (valid === true) {
          console.log("Retrying updateDynamicOptions api call");
          updateDynamicOptions();
        } else if (valid === false) {
          console.log("all retries failed updateDynamicOptions");
          navigate("/login");
        }
      } else {
        console.log(
          "Redirecting to login something went wrong in updateDynamicOptions"
        );
        navigate("/login");
      }
      return;
    }
  };
  const updateStaticOptionsViaDyn = async () => {
    console.log("Update static via dyn options STARTED");
    const auth = await getAuth();
    const getCardOptions = async () => {
      const optionsToSend = {
        method: "GET",
        url: `https://api.pramsplus.com/web-cards/${instance}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${auth}`,
        },
      };
      try {
        const response = await axios.request(optionsToSend);
        console.log(
          "web card patch static end res via dyn",
          response.data.options
        );
        return response.data.options;
      } catch (err) {
        console.log(err.response.status);
        if (err.response.status === 401) {
          const valid = await refreshCheck("getData");
          if (valid === true) {
            console.log("Retrying updateStaticOptionsViaDyn api call");
            getCardOptions();
          } else if (valid === false) {
            console.log("all retries failed updateStaticOptionsViaDyn");
            navigate("/login");
          }
        } else {
          console.log(
            "Redirecting to login something went wrong in updateStaticOptionsViaDyn"
          );
          navigate("/login");
        }
        return;
      }
    };
    const updatedOpts = await getCardOptions();
    console.log("updateStaticOptionsViaDyn updatedOpts", updatedOpts);

    const cleanedUpOpts = updatedOpts.filter(
      (item) => item.optionId !== "staticSiteList"
    );
    console.log("updateStaticOptionsViaDyn cleanedUpOpts", cleanedUpOpts);
    const prepareDataForAxios = (updatedOpts) => {
      const formattedOpts = updatedOpts.map((opt) => ({
        optionId: opt.optionId || opt.option_id,
        optionValue: opt.optionValue || opt.value,
      }));

      return {
        options: formattedOpts,
      };
    };
    const readyToSend = prepareDataForAxios(cleanedUpOpts);
    console.log("readyToSend", readyToSend);

    const opts = readyToSend;

    const optionsToSend = {
      method: "PATCH",
      url: `https://api.pramsplus.com/web-cards/${instance}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${auth}`,
      },
      data: opts,
    };
    console.log("options to Send ", optionsToSend);

    try {
      const response = await axios.request(optionsToSend);
      console.log("web card patch static end res via dyn", response);
      setSiteIds([]);
      initStaticOrDynamic();
    } catch (err) {
      console.log(err.response.status);
      if (err.response.status === 401) {
        const valid = await refreshCheck("updateStaticOptionsViaDyn");
        if (valid === true) {
          console.log("Retrying updateStaticOptionsViaDyn api call");
          updateStaticOptionsViaDyn();
        } else if (valid === false) {
          console.log("all retries failed updateStaticOptionsViaDyn");
          navigate("/login");
        }
      } else {
        console.log(
          "Redirecting to login something went wrong in updateStaticOptionsViaDyn"
        );
        navigate("/login");
      }
      return;
    }
  };
  const cleanUpOptsToSend = async () => {
    const auth = getAuth();
    const getCardOptions = async () => {
      const optionsToSend = {
        method: "GET",
        url: `https://api.pramsplus.com/web-cards/${instance}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${auth}`,
        },
      };
      try {
        const response = await axios.request(optionsToSend);
        console.log(
          "web card patch static end res via dyn",
          response.data.options
        );
        return response.data.options;
      } catch (err) {
        console.log(err.response.status);
        if (err.response.status === 401) {
          const valid = await refreshCheck("getData");
          if (valid === true) {
            console.log("Retrying updateStaticOptionsViaDyn api call");
            getCardOptions();
          } else if (valid === false) {
            console.log("all retries failed updateStaticOptionsViaDyn");
            navigate("/login");
          }
        } else {
          console.log(
            "Redirecting to login something went wrong in updateStaticOptionsViaDyn"
          );
          navigate("/login");
        }
        return;
      }
    };
    const refreshOptions = await getCardOptions();
    console.log("cleanUpOptsToSend refreshOptions dirty", refreshOptions);
    const cleanedUpOpts = refreshOptions.filter(
      (item) => item.optionId !== "staticSiteList"
    );
    console.log("cleanUpOptsToSend cleanedUpOpts", cleanedUpOpts);
    const staticList = siteIds;
    console.log("cleanUpOptsToSend staticList", staticList);
    const stringSites = staticList.join(",");
    console.log("cleanUpOptsToSend string", stringSites);
    const updatedOpts = [
      ...cleanedUpOpts,
      {
        optionId: "staticSiteList",
        optionValue: stringSites,
      },
    ];
    console.log("cleanUpOptsToSend updatedOpts", updatedOpts);
    const prepareDataForAxios = (updatedOpts) => {
      const formattedOpts = updatedOpts.map((opt) => ({
        optionId: opt.optionId || opt.option_id,
        optionValue: opt.optionValue || opt.value,
      }));
      return {
        options: formattedOpts,
      };
    };
    const payload = prepareDataForAxios(updatedOpts);
    console.log("cleanUpOptsToSend final payload", payload);
    setStatOpts(payload);
    return;
  };
  const updateStaticOptions = async () => {
    console.log("updateStaticOptions started");
    const auth = await getAuth();
    const opts = statOpts;
    console.log("options to Send updateStaticOptions ", opts);
    const optionsToSend = {
      method: "PATCH",
      url: `https://api.pramsplus.com/web-cards/${instance}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${auth}`,
      },
      data: opts,
    };

    try {
      setTreeSave(false);
      setStatOpts([]);
      const response = await axios.request(optionsToSend);
      console.log("web card patch end res updateStaticOptions", response);
      // return;
      props.reload();
    } catch (err) {
      console.log(err.response.status);
      if (err.response.status === 401) {
        const valid = await refreshCheck("updateStaticOptions");
        if (valid === true) {
          console.log("Retrying updateStaticOptions api call");
          updateStaticOptions();
        } else if (valid === false) {
          console.log("all retries failed updateStaticOptions");
          navigate("/login");
        }
      } else {
        console.log(
          "Redirecting to login something went wrong in updateStaticOptions"
        );
        navigate("/login");
      }
      return;
    }
  };
  const clearDynOptions = async () => {
    const auth = await getAuth();
    const opts = {
      dynamicOptions: [],
    };
    const options = {
      method: "PATCH",
      url: `https://api.pramsplus.com/web-cards/${instance}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${auth}`,
      },
      data: opts,
    };
    console.log("options clearDynOptions", options);
    try {
      const response = await axios.request(options);
      console.log("web card patch clearDynOptions", response);
      setRows([
        {
          fieldText: "",
          fieldValue: "",
          comparison: "",
          optionValue: "",
          optionText: "",
        },
      ]);
      // props.reload();
      return;
    } catch (err) {
      console.log(err.response.status);
      if (err.response.status === 401) {
        const valid = await refreshCheck("clearDynOptions");
        if (valid === true) {
          console.log("Retrying clearDynOptions api call");
          clearDynOptions();
        } else if (valid === false) {
          console.log("all retries failed clearDynOptions");
          navigate("/login");
        }
      } else {
        console.log(
          "Redirecting to login something went wrong in clearDynOptions"
        );
        navigate("/login");
      }
      return;
    }
  };
  const removeCard = async () => {
    const auth = await getAuth();
    const options = {
      method: "DELETE",
      url: `https://api.pramsplus.com/web-cards/${instance}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${auth}`,
      },
    };
    console.log("options", options);
    try {
      const response = await axios.request(options);
      console.log("web card deleted", response);
      handleClose();
      props.reload();
    } catch (err) {
      console.log(err.response.status);
      if (err.response.status === 401) {
        const valid = await refreshCheck("removeCard");
        if (valid === true) {
          console.log("Retrying removeCard api call");
          removeCard();
        } else if (valid === false) {
          console.log("all retries failed removeCard");
          navigate("/login");
        }
      } else {
        console.log("Redirecting to login something went wrong in removeCard");
        navigate("/login");
      }
      return;
    }
  };
  const handleCardNameChange = (e) => {
    const { name, value } = e.target;
    setCardNameForm((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const saveCardName = async (props) => {
    console.log("saveCardName props", props);
    if (props === 1) {
      const auth = await getAuth();
      const initOptions = userCardOptions.filter(
        (option) => option.instance_id === instance
      );
      console.log("saveCardName initOpts 1", initOptions);
      const filteredOpts = initOptions.filter((option) => {
        return option.option_id !== "userDefName";
      });
      console.log(" saveCardName filteredUpOpts 1", filteredOpts);
      const cleanedUpOpts = filteredOpts.map((option) => {
        return {
          optionId: option.option_id,
          optionValue: option.value,
        };
      });
      console.log(" saveCardName cleanedUpOpts 1", cleanedUpOpts);
      const optsToSend = [
        ...cleanedUpOpts,
        {
          optionId: "userDefName",
          optionValue: cardNameForm.Card_Name,
        },
      ];
      console.log("optsToSend saveCardName 1", optsToSend);
      const opts = {
        options: optsToSend,
      };
      const options = {
        method: "PATCH",
        url: `https://api.pramsplus.com/web-cards/${instance}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${auth}`,
        },
        data: opts,
      };
      console.log("options saveCardName 1", options);
      try {
        const response = await axios.request(options);
        console.log("web card patch saveCardName 1", response.status);
        return;
      } catch (err) {
        console.log(err.response.status);
        if (err.response.status === 401) {
          const valid = await refreshCheck("saveCardName");
          if (valid === true) {
            console.log("Retrying saveCardName api call");
            saveCardName(props);
          } else if (valid === false) {
            console.log("all retries failed saveCardName");
            navigate("/login");
          }
        } else {
          console.log(
            "Redirecting to login something went wrong in saveCardName"
          );
          navigate("/login");
        }
        return;
      }
    } else if (props === 2) {
      const auth = await getAuth();
      const initOptions = userCardOptions.filter(
        (option) => option.instance_id === instance
      );
      console.log("saveCardName initOpts 2", initOptions);
      const filteredOpts = initOptions.filter((option) => {
        return option.option_id !== "userDefName";
      });
      console.log(" saveCardName filteredUpOpts 2", filteredOpts);
      const cleanedUpOpts = filteredOpts.map((option) => {
        return {
          optionId: option.option_id,
          optionValue: option.value,
        };
      });
      console.log("saveCardName cleanedUpOpts 2", cleanedUpOpts);
      const optsToSend = [
        ...cleanedUpOpts,
        {
          optionId: "userDefName",
          optionValue: cardNameForm.Card_Name,
        },
      ];
      console.log("optsToSend saveCardName 2", optsToSend);
      const refreshedOpts = optsToSend.map((opt) => ({
        instance_id: instance,
        option_id: opt.optionId,
        value: opt.optionValue,
      }));
      console.log("saveCardName refreshedOpts 2", refreshedOpts);
      const opts = {
        options: optsToSend,
      };
      const options = {
        method: "PATCH",
        url: `https://api.pramsplus.com/web-cards/${instance}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${auth}`,
        },
        data: opts,
      };
      console.log("options saveCardName", options);
      try {
        const response = await axios.request(options);
        console.log("web card patch saveCardName", response.status);
        await saveUsePreviousDaySwitch(refreshedOpts);
      } catch (err) {
        console.log(err.response.status);
        if (err.response.status === 401) {
          const valid = await refreshCheck("saveCardName");
          if (valid === true) {
            console.log("Retrying saveCardName api call");
            saveCardName(props);
          } else if (valid === false) {
            console.log("all retries failed saveCardName");
            navigate("/login");
          }
        } else {
          console.log(
            "Redirecting to login something went wrong in saveCardName"
          );
          navigate("/login");
        }
        return;
      }
    }
  };
  const handleDayBackSwitchChange = () => {
    setUsePrevDaySwitch(!usePrevDaySwitch);
    setSwitchChanged(true);
  };
  const saveUsePreviousDaySwitch = async (props) => {
    if (props) {
      console.log("saveUsePreviousDaySwitch props", props);
      const auth = await getAuth();
      const initOptions = props.filter(
        (option) => option.instance_id === instance
      );
      console.log("saveUsePreviousDaySwitch props", initOptions);
      const cleanedUpOpts = initOptions.map((option) => {
        return {
          optionId: option.option_id,
          optionValue: option.value,
        };
      });
      // Ensure usePrevDaySwitch is added as a string
      const switchOption = {
        optionId: "usePrevDaySwitch",
        optionValue: usePrevDaySwitch ? "true" : "false",
      };
      const optsToSend = [
        ...cleanedUpOpts.filter((opt) => opt.optionId !== "usePrevDaySwitch"), // avoid dupes
        switchOption,
      ];
      console.log(
        "Final payload to send saveUsePreviousDaySwitch (optsToSend):",
        JSON.stringify(optsToSend, null, 2)
      );
      const requestBody = {
        options: optsToSend,
      };
      const options = {
        method: "PATCH",
        url: `https://api.pramsplus.com/web-cards/${instance}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${auth}`,
          Accept: "application/json",
        },
        data: JSON.stringify(requestBody),
      };
      try {
        const response = await axios.request(options);
        console.log(
          "web card patch saveUsePreviousDaySwitch response",
          response
        );
        if (response.status === 200) {
          console.log("Save successful");
          return;
        }
      } catch (err) {
        console.log(
          "Error response in saveUsePreviousDaySwitch",
          err?.response
        );

        if (err?.response) {
          console.log("Response data:", err.response.data);
          console.log("Response headers:", err.response.headers);
        }

        if (err.response?.status === 401) {
          const valid = await refreshCheck("saveUsePreviousDaySwitch");
          if (valid === true) {
            console.log("Retrying saveUsePreviousDaySwitch API call");
            saveUsePreviousDaySwitch();
          } else {
            console.log("All retries failed, redirecting to login");
            navigate("/login");
          }
        } else {
          console.log(
            "Redirecting to login, something went wrong in saveUsePreviousDaySwitch"
          );
          navigate("/login");
        }
      }
    } else if (!props) {
      console.log("saveUsePreviousDaySwitch no props", props);
      const auth = await getAuth();
      const initOptions = userCardOptions.filter(
        (option) => option.instance_id === instance
      );
      console.log("saveUsePreviousDaySwitch initOpts no props", initOptions);
      const cleanedUpOpts = initOptions.map((option) => {
        return {
          optionId: option.option_id,
          optionValue: option.value,
        };
      });
      // Ensure usePrevDaySwitch is added as a string
      const switchOption = {
        optionId: "usePrevDaySwitch",
        optionValue: usePrevDaySwitch ? "true" : "false",
      };
      // Add it to the payload
      const optsToSend = [
        ...cleanedUpOpts.filter((opt) => opt.optionId !== "usePrevDaySwitch"), // avoid dupes
        switchOption,
      ];
      console.log(
        "Final payload to send saveUsePreviousDaySwitch (optsToSend) no props:",
        JSON.stringify(optsToSend, null, 2)
      );
      const requestBody = {
        options: optsToSend,
      };
      const options = {
        method: "PATCH",
        url: `https://api.pramsplus.com/web-cards/${instance}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${auth}`,
          Accept: "application/json",
        },
        data: JSON.stringify(requestBody),
      };
      console.log("saveUsePreviousDaySwitch no props options", options);
      try {
        const response = await axios.request(options);
        console.log(
          "web card patch saveUsePreviousDaySwitch response no props",
          response
        );
        return;
      } catch (err) {
        console.log(
          "Error response in saveUsePreviousDaySwitch no props",
          err?.response
        );
        if (err?.response) {
          console.log("Response data:", err.response.data);
          console.log("Response headers:", err.response.headers);
        }
        if (err.response?.status === 401) {
          const valid = await refreshCheck("saveUsePreviousDaySwitch");
          if (valid === true) {
            console.log("Retrying saveUsePreviousDaySwitch API call");
            saveUsePreviousDaySwitch(props);
          } else {
            console.log("All retries failed, redirecting to login");
            navigate("/login");
          }
        } else {
          console.log(
            "Redirecting to login, something went wrong in saveUsePreviousDaySwitch"
          );
          navigate("/login");
        }
      }
    }
  };
  return (
    <Container fluid id="gasTodayCard-container" style={{ maxHeight: "175px" }}>
      {/* <Button onClick={runTest}>Test</Button> */}
      {loading ? (
        <Row className="text-center" style={{ paddingTop: "35px", marginTop: "10px" }}>
          <Col>
            <Spinner animation="border" size="lg" variant="primary" />
          </Col>
        </Row>
      ) : (
        <>
          <Row>
            <Col className="text-center">
              {todayGas ? (
                <h1 className={yestPercentStyle} id="today-gas">
                  {todayGas}
                </h1>
              ) : (
                <h1 className={yestPercentStyle}>-</h1>
              )}
            </Col>
          </Row>
          <Row className="text-center">
            <Col style={{ padding: "0px", marginTop: "10px" }}>
              <h6>
                {usePrevDaySwitch ? "Prev. Day" : "Yesterday"}:{" "}
                {yesterdayGas ? yesterdayGas : "-"}
              </h6>
            </Col>
            <Col style={{ padding: "0px", marginTop: "10px" }}>
              <h6 className={yestPercentStyle}>
                {yestPercent ? yestPercent : "-%"}
              </h6>
            </Col>
          </Row>
          <Button
            id="card-button-settings"
            variant="secondary"
            onClick={() => {
              handleShow();
            }}
          >
            <MoreHorizIcon id="icon-button" />
          </Button>
          <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size="lg"
          >
            <Modal.Header closeButton>
              <Modal.Title>Card Options - {cardName}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row style={{ paddingTop: "10px" }}>
                <Alert
                  show={showRemoveCardAlert}
                  key="danger"
                  variant="danger"
                  onClose={() => handleCloseRemoveCardAlert()}
                  dismissible
                >
                  <Row>
                    <Col>
                      <h6>Are you sure you want to remove this card?</h6>
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <ButtonGroup>
                      <Button variant="danger" onClick={() => removeCard()}>
                        Yes
                      </Button>
                      <Button
                        variant="primary"
                        onClick={() => handleCloseRemoveCardAlert()}
                      >
                        No
                      </Button>
                    </ButtonGroup>
                  </Row>
                </Alert>
              </Row>
              <Row>
                <h6>Card settings:</h6>
              </Row>
              <Row>
                <InputGroup className="mb-3">
                  <InputGroup.Text>Card Name: </InputGroup.Text>
                  <Form.Control
                    placeholder=" ex. Gas for K3 pad (24 char limit)"
                    aria-label="Card Name"
                    type="text"
                    name="Card_Name"
                    value={cardNameForm.Card_Name}
                    onChange={handleCardNameChange}
                  />
                  {/* <Button
                    id="save-card-name"
                    variant="primary"
                    onClick={() => saveCardName()}
                  >
                    Save Card Name
                  </Button> */}
                </InputGroup>
              </Row>
              <Row className="justify-content-end">
                <Col>
                  <InputGroup className="mb-3">
                    <InputGroup.Text>Delete Card:</InputGroup.Text>
                    <Col sm={4}>
                      <Button
                        variant="danger"
                        onClick={() => handleShowRemoveCardAlert()}
                      >
                        Remove Card
                      </Button>
                    </Col>
                  </InputGroup>
                </Col>
                <Col>
                  <InputGroup className="mb-3">
                    <InputGroup.Text>Use Previous Days' Data:</InputGroup.Text>
                    <Col sm={4}>
                      <Form>
                        <Form.Check
                          type="switch"
                          id="usePrevDaySwitch"
                          checked={usePrevDaySwitch}
                          onChange={() => handleDayBackSwitchChange()}
                        />
                      </Form>
                    </Col>
                  </InputGroup>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Body>
              <Row>
                <ButtonGroup>
                  <Button onClick={() => toggleStaticDynamic("static")}>
                    Static List
                  </Button>
                  <Button onClick={() => toggleStaticDynamic("dynamic")}>
                    Dynamic List
                  </Button>
                </ButtonGroup>
              </Row>
              <Row>
                {showStaticOrDynamic === "static" ? (
                  <StaticSiteSearchTool
                    saveSitesTree={saveSitesTreeForStatic}
                    siteIdsOptions={siteIds}
                  />
                ) : (
                  <>
                    <Table hover>
                      <thead>
                        <tr className="text-center">
                          <th>Field</th>
                          <th>Comparison</th>
                          <th>Value</th>
                          <th>Remove</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rows.map((row, index) => (
                          <tr key={index}>
                            <td style={{ padding: "0px" }}>
                              <Form.Select
                                id="field"
                                value={row.fieldId}
                                onChange={(event) =>
                                  handleFieldChange(
                                    index,
                                    event.target.value,
                                    event.target.options[
                                      event.target.selectedIndex
                                    ].text
                                  )
                                }
                              >
                                <option value={rows[index].fieldValue}>
                                  {rows[index].fieldText}
                                </option>
                                {fieldCombiOptions.map((option, index) => (
                                  <option
                                    key={index}
                                    value={option.key}
                                    label={option.value}
                                  >
                                    {option.value}
                                  </option>
                                ))}
                              </Form.Select>
                            </td>
                            <td style={{ padding: "0px" }}>
                              <Form.Select
                                id="operator"
                                value={row.comparison}
                                onChange={(event) =>
                                  handleComparisonChange(
                                    index,
                                    event.target.value
                                  )
                                }
                              >
                                <option value={rows[index].comparison}>
                                  {rows[index].comparison}
                                </option>
                                {comparisonOptions.map((comparison, index) => (
                                  <option key={index} value={comparison}>
                                    {comparison}
                                  </option>
                                ))}
                              </Form.Select>
                            </td>
                            <td style={{ padding: "0px" }}>
                              <Form.Select
                                id="value"
                                value={row.value}
                                onChange={(event) =>
                                  handleValueChange(
                                    index,
                                    event.target.value,
                                    event.target.options[
                                      event.target.selectedIndex
                                    ].text
                                  )
                                }
                              >
                                <option value={rows[index].optionValue}>
                                  {rows[index].optionText}
                                </option>
                                {valueOptions[row.fieldId]?.map(
                                  (valueOptions, index) => (
                                    <option
                                      key={index}
                                      value={valueOptions.value}
                                      label={valueOptions.label}
                                    >
                                      {valueOptions.label}
                                    </option>
                                  )
                                )}
                              </Form.Select>
                            </td>
                            <td
                              className="text-center"
                              style={{ padding: "0px" }}
                            >
                              <Button
                                variant="danger"
                                onClick={(event) => {
                                  handleDeleteRow(event, index);
                                }}
                              >
                                <DeleteForeverIcon />
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    <Row>
                      {dynViewSiteList ? (
                        <Card id="Dyn-Card-Sites">
                          <Card.Header className="text-end">
                            <Row>
                              <Col>
                                <Row>Site List - {dynSiteCount}</Row>
                                <Row>
                                  Viewing by -{" "}
                                  {urOrSn === "userRef"
                                    ? "User Ref"
                                    : "Site Name"}
                                </Row>
                              </Col>
                              <Col>
                                <ButtonGroup>
                                  <Button onClick={() => setUrOrSn("userRef")}>
                                    User Ref
                                  </Button>
                                  <Button
                                    onClick={() => setUrOrSn("nameNumber")}
                                  >
                                    Site Name
                                  </Button>
                                  <Button
                                    variant="danger"
                                    onClick={() => setDynViewSiteList(false)}
                                  >
                                    <CloseIcon />
                                  </Button>
                                </ButtonGroup>
                              </Col>
                            </Row>
                          </Card.Header>
                          <Card.Body id="Dyn-Card-Site-List">
                            {urOrSn === "userRef" ? (
                              <ListGroup>
                                {dynSites.map((site, index) => (
                                  <ListGroup.Item key={index}>
                                    {site.userRef}
                                  </ListGroup.Item>
                                ))}
                              </ListGroup>
                            ) : (
                              <ListGroup>
                                {dynSites.map((site, index) => (
                                  <ListGroup.Item key={index}>
                                    {site.nameNumber}
                                  </ListGroup.Item>
                                ))}
                              </ListGroup>
                            )}
                          </Card.Body>
                        </Card>
                      ) : (
                        <></>
                      )}
                    </Row>
                    <Row>
                      <br />
                      <ButtonGroup id="bottom-buttons">
                        {/* <Button variant="success" onClick={showRow}>
                          Test
                        </Button> */}
                        <Button
                          variant="success"
                          onClick={() => {
                            addDynamicRow();
                          }}
                        >
                          Add a Filter
                        </Button>
                        <Button
                          variant="secondary"
                          onClick={() => {
                            handleViewSites("button");
                          }}
                        >
                          View Sites
                        </Button>
                      </ButtonGroup>
                    </Row>
                  </>
                )}
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => {
                  handleClose();
                }}
              >
                Close - Discard Changes
              </Button>
              {showStaticOrDynamic === "static" ? (
                <></>
              ) : (
                <Button
                  variant="primary"
                  id="save-dynamic-options"
                  disabled={rows.length === 0}
                  onClick={() => {
                    saveSitesButtonForDynamic();
                    handleClose();
                  }}
                >
                  Save Changes
                </Button>
              )}
            </Modal.Footer>
          </Modal>
        </>
      )}
    </Container>
  );
};
export default GasCardToday;
